import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
// components
import { Bank } from "../../../../components/modules/accounting/bank";
import BankMiddleware from "../../../../middleware/modules/accounting/bank";
import Coa3Middleware from "../../../../middleware/modules/accounting/coa3";
import { Helmet } from "react-helmet";
import i18n from "../../../../i18n";
// middlewares

const mapStateToProps = ({ auth, bank }) => ({
  isProcessing: bank.isProcessing,
  isError: bank.isError,
  errorMessage: bank.errorMessage,
  datalist: bank.data,
  showModal: bank.showModal,
});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      getHelper: () => BankMiddleware.getHelperFull(),
      create: () => BankMiddleware.create(),
      reset: () => BankMiddleware.resetList(),
      search: (data) => BankMiddleware.list(data),
      update: (data) => BankMiddleware.update(data),
      delete: (id, search) => BankMiddleware.beforeDelete(id, search),
    },
    dispatch
  );
};
class BankContainer extends Component {
  static propTypes = {
    isAuthenticated: PropTypes.bool,
    isProcessing: PropTypes.bool,
    isRegistered: PropTypes.bool,
    isError: PropTypes.bool,
    errorMessage: PropTypes.any,
    datalist: PropTypes.object,
    search: PropTypes.func.isRequired,
  };

  static defaultProps = {
    isAuthenticated: false,
    isProcessing: false,
    isRegistered: false,
    isError: false,
    errorMessage: [],
  };

  constructor(props) {
    super(props);
    this.deleteItem = this.deleteItem.bind(this);
    this.createItem = this.createItem.bind(this);
    this.updateItem = this.updateItem.bind(this);
  }

  componentWillMount() {
    const search = {
      limit: 10,
    };
    this.props.reset();
    this.props.search(search);
  }

  deleteItem(id, search) {
    this.props.delete(id, search);
  }
  updateItem(id) {
    this.props.getHelper();
    this.props.update(id);
  }
  createItem() {
    this.props.getHelper();
    this.props.create();
  }
  render() {
    const { isProcessing, search, datalist, showModal } = this.props;
    return (
      <React.Fragment>
        <Helmet>
          <title>{i18n.t("Bank List")}</title>
        </Helmet>

        <Bank
          search={search}
          data={datalist}
          isProcessing={isProcessing}
          showModal={showModal}
          deleteItem={this.deleteItem}
          updateItem={this.updateItem}
          createData={this.createItem}
        />
      </React.Fragment>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(BankContainer);
